import styled, {css} from 'styled-components';

//helpers
import {transparentize} from 'utils/color-utils';
import {buttonMetrics} from 'styles/metrics';
import {commonPalette} from 'styles/palette';

//components
import $Link from 'components/Link';

export const StyledButton = styled.button`
  align-items: center;
  border-radius: 4px;
  border: 0;
  cursor: pointer;
  display: inline-flex;
  font-size: 14px;
  font-style: normal;
  font-variant: normal;
  font-weight: 400;
  justify-content: center;
  outline: 0;
  padding: 0 16px;
  position: relative;
  text-decoration: none;
  text-transform: uppercase;
  white-space: nowrap;
  height: ${buttonMetrics.height}px;
  min-width: 92px;

  &:disabled {
    cursor: default;
    pointer-events: none;
  }

  ${p =>
    p.loading &&
    css`
      ${() => StyledButtonCaption} {
        visibility: hidden;
      }
    `}

  ${p =>
    p.block &&
    `
    display: flex;
    width: 100%;
  `}


  ${p =>
    ['solid', 'solid-black', 'solid-white'].includes(p.design) &&
    `
    box-shadow:
      0 0 1px rgba(0, 0, 0, 0.12),
      0 1px 1px rgba(0, 0, 0, 0.24);
    color: #fff !important;

    &:disabled {
      box-shadow: none;
      opacity: 0.5;
    }
  `}

  ${p =>
    p.design === 'solid' &&
    `
    background: ${commonPalette.surfaceBrand};
    color: #fff !important;

    &:disabled {
      opacity: 0.5;
      background: ${commonPalette.surfaceBrand};
    }
    &:not(:disabled):hover {
      background: ${commonPalette.interactionPrimaryHover};
    }
    &:focus {
      background: ${commonPalette.interactionPrimaryHover};
      box-shadow: ${commonPalette.focusShadow};
    }
    &:active {
      background: ${commonPalette.interactionPrimaryPressed};
    }
  `}

  ${p =>
    p.design === 'white-green' &&
    `
    background: #fff !important;
    color: ${commonPalette.textBrand}; 
    border: 1px solid ${commonPalette.borderGrey};

    &:focus,
    &:not(:disabled):hover {
      background: ${commonPalette.hoverGrey} !important;
      border: 1px solid ${commonPalette.borderGrey};
    }
  `}

  ${p =>
    p.design === 'solid-black' &&
    `
    background: #323232;
    color: #fff !important;

    &:focus,
    &:not(:disabled):hover {
      background: #000;
    }
  `}

  ${p =>
    ['solid-white', 'solid-cool'].includes(p.design) &&
    `
    background: #fff;
    color: #000 !important;

    &:focus,
    &:not(:disabled):hover {
      background: #fafafa;
    }
  `}

  ${p =>
    p.design === 'solid-cool' &&
    `
    border: 1px solid ${commonPalette.borderGrey};
    text-transform: none;
    border-radius: 3px;
    box-shadow: none;
    font-family: Lato;
    justify-content: unset;
    box-sizing: border-box;
    font-size: 1rem;
    font-weight: 500; // font weight normal for this cool solid mode
    color: ${commonPalette.txBlack} !important;
  `}



  ${p =>
    p.design === 'outline' &&
    `
    background: #fff;
    color: ${commonPalette.textBrand};
    border: 1px solid ${commonPalette.strokeBrand};

    &:disabled {
      opacity: 0.5;
      border: 1px solid ${commonPalette.strokeBrand};
    }
    &:not(:disabled):hover {
      background: ${commonPalette.interactionHover};
    }
    &:focus {
      background: ${commonPalette.interactionHover};
      box-shadow: ${commonPalette.focusShadow};
    }
    &:active {
      background: ${commonPalette.interactionPressed};
    }
  `}

  ${p =>
    ['text', 'text-alternative-hover', 'text-black'].includes(p.design) &&
    `
    background: none;
  `}

  ${p =>
    ['text', 'text-alternative-hover'].includes(p.design) &&
    `
    color: ${commonPalette.btnGreen} !important;
  `}

  ${p =>
    ['text-alternative-hover', 'text-black'].includes(p.design) &&
    `
    padding-left: 0;
    padding-right: 0;
  `}

  ${p =>
    p.design === 'text' &&
    `
    &:focus,
    &:not(:disabled):hover {
      background: ${transparentize(commonPalette.btnGreen, 0.2)};
    }
  `}

  ${p =>
    p.design === 'text-alternative-hover' &&
    `
    &:focus,
    &:not(:disabled):hover {
      color: ${commonPalette.btnHoverGreen} !important;
    }
  `}

  ${p =>
    p.design === 'text-black' &&
    `
    color: #000 !important;;

    &:focus,
    &:not(:disabled):hover {
      color: rgba(0, 0, 0, 0.65) !important;;
    }
  `}
`;

export const StyledAnchor = StyledButton.withComponent('a');

export const StyledLink = StyledButton.withComponent($Link);

export const StyledButtonCaption = styled.div`
  ${p =>
    p.isInvisible &&
    `
    visibility: hidden;

  `}

  width: 100%;
`;

export const StyledButtonGroup = styled.div`
  display: flex;
  flex-direction: ${p => p.direction || 'row'};

  > ${() => StyledButton} {
    display: flex;
    flex-shrink: 0;

    + ${() => StyledButton} {
      margin-left: ${buttonMetrics.gutter}px;
    }
  }

  ${p =>
    p.shouldAllowWrapping &&
    css`
      flex-wrap: wrap;
      margin-top: ${-buttonMetrics.gutter}px;

      > ${StyledButton} {
        margin-top: ${buttonMetrics.gutter}px;
      }
    `}
`;
